import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {reduxForm, Field} from 'redux-form';
import {I18n} from 'react-redux-i18n';

import FormInput from '../../common/components/FormInput';

import * as endpoints from '../../common/apiEndpoints';

 import DemoModal from './DemoModal';



const LoginForm = ({
  attemptingLogin,
  handleSubmit, 
  submitFailed,
  isOpen,
  onDemoClose,
  onStartDemo,
  onOpenDemoModal 
}) => {
  let signupLink = endpoints.SIGNUP_EN;
  let browserLanguage = window.navigator.language;
  browserLanguage = browserLanguage.substring(0, 2);
  if(browserLanguage === 'de')
  {
    signupLink = endpoints.SIGNUP_DE;
  } 


  return (
      <div id="login-form-container">
        <div className="container login">
          <form className="form-login" onSubmit={handleSubmit}>
            <div className="logo-login">
              <Link to="/">{I18n.t('pet_data')}</Link>
            </div>

            {submitFailed && 
              <div className="alert alert-danger" role="alert">
                <span className="lnr lnr-cross-circle" aria-hidden="true"/>
                <span className="form-error-text">{I18n.t('INVALID_CREDENTIALS')}</span>
                {I18n.t('PLEASE_REENTER')}
              </div>
            }

            <label htmlFor="email" className="sr-only">{I18n.t('EMAIL_ADDRESS')}</label>
            <Field  name="email" 
                    component={FormInput} 
                    type="text" 
                    className="form-control"
                    placeholder={I18n.t('EMAIL_ADDRESS')}  
            />

            <label htmlFor="password" className="sr-only">{I18n.t('PASSWORD')}</label>
            <Field  name="password" 
                    component={FormInput}
                    type="password"
                    className="form-control"
                    placeholder={I18n.t('PASSWORD')} 
            />

            <div className="forgot-password">
              <Field  name="remember" 
                      component={FormInput}
                      type="checkbox"
                      className="form-checkbox" 
              />
              
              <label htmlFor="checkRemember" className="checkbox-label">{I18n.t('REMEMBER_ME')}</label>
              <Link to="/forgot" className="forgot-password-link">{I18n.t('FORGOT_PASSWORD')}</Link>
            </div>

            <button type="submit" className="btn btn-login" disabled={attemptingLogin}>{I18n.t('LOG_IN')}</button>

            <div className="no-account">
              {I18n.t('NO_ACCOUNT')} 
            </div>
            <div className="account-text">
              <a href={signupLink} target="_blank">{I18n.t('SIGN_UP')}</a>
              {I18n.t('OR')}
              <a onClick={(e) => {e.preventDefault();onOpenDemoModal();}} href="" >{I18n.t('VIEW_DEMO')}</a>
              {/* <Link onClick={onOpenDemoModal}>{I18n.t('VIEW_DEMO')}</Link> */}
              
            </div>
          </form>
          {/* <button className="btn btn-login"  onClick={onOpenDemoModal}>{I18n.t('LOG_IN')}</button> */}
        </div>
        { <DemoModal isOpen={isOpen} onClose={onDemoClose} onStartDemo={onStartDemo}/>}
      </div>
    );
};

LoginForm.propTypes = {
  attemptingLogin: PropTypes.bool,
  email: PropTypes.string,
  form: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSubmitFail: PropTypes.func.isRequired,
  onDemoClose: PropTypes.func.isRequired,
  onStartDemo: PropTypes.func.isRequired,
  onOpenDemoModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired, 
  submitFailed: PropTypes.bool.isRequired,
  validate: PropTypes.func.isRequired
};


export default reduxForm()(LoginForm);


/** WEBPACK FOOTER **
 ** ./src/modules/customer/components/LoginForm.js
 **/